import { http } from '../request'
import type { PaginationData } from '../request'
import type {
    GameRank,
    GameRankCreateRequest,
    GameRankUpdateRequest,
    GameRankCreateResponse,
    GameRankUpdateResponse
} from '../types/ranks'

/**
 * 游戏段位相关 API
 */
export const ranksApi = {
    /**
     * 获取所有段位数据（分页格式）
     * GET /api/ranks/
     */
    getAllRanks(params?: { page?: number; size?: number }): Promise<PaginationData<GameRank>> {
        return http.get<PaginationData<GameRank>>('/api/ranks/', { params })
    },

    /**
     * 创建段位
     * POST /api/ranks/
     */
    createRank(data: GameRankCreateRequest): Promise<GameRankCreateResponse> {
        return http.post<GameRankCreateResponse>('/api/ranks/', data)
    },

    /**
     * 更新段位
     * PUT /api/ranks/{id}/
     */
    updateRank(id: number, data: GameRankUpdateRequest): Promise<GameRankUpdateResponse> {
        return http.put<GameRankUpdateResponse>(`/api/ranks/${id}/`, data)
    },

    /**
     * 删除段位
     * DELETE /api/ranks/{id}/
     */
    deleteRank(id: number): Promise<void> {
        return http.delete<void>(`/api/ranks/${id}/`)
    }
}

export default ranksApi 